export default __webpack_public_path__ + "static/media/lap.94f85f5c.png";